import Resource from '@/api/resources/Resource'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'

class TakeOutFromLaboratoryService extends Resource {
    async getUnarchivingReasons(laboratoryId) {
        return this.axios.get(`/archive/laboratories/${laboratoryId}/unarchivingReasons`)
            .then(response => response.data)
    }
    takeOutFromLaboratory(laboratoryId, elements, entityType) {
        switch (entityType) {
        case COREENTITY_VALUES.SAMPLE:
            return this.takeOutSamplesFromLaboratory(laboratoryId, elements)
        case COREENTITY_VALUES.PORTION:
            return this.takeOutPortionsFromLaboratory(laboratoryId, elements)
        case COREENTITY_VALUES.SUBPORTION:
            return this.takeOutSubportionsFromLaboratory(laboratoryId, elements)
        default:
            throw new Error(`unexpected entity ${entityType.id} in takeOutFromLaboratory`)
        }
    }
    takeOutSamplesFromLaboratory(laboratoryId, elements) {
        return this.axios.put(`/archive/laboratories/${laboratoryId}/cases/samples/takeOutFromLaboratory`, elements).then(response => response.data)
    }
    takeOutPortionsFromLaboratory(laboratoryId, elements) {
        return this.axios.put(`/archive/laboratories/${laboratoryId}/cases/samples/portions/takeOutFromLaboratory`, elements).then(response => response.data)
    }
    takeOutSubportionsFromLaboratory(laboratoryId, elements) {
        return this.axios.put(`/archive/laboratories/${laboratoryId}/cases/samples/portions/subportions/takeOutFromLaboratory`, elements).then(response => response.data)
    }
}
export default new TakeOutFromLaboratoryService()
